import React, { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";
import { firestore } from "../../../firebase";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

function AddShopPopup({ open, handleClose }) {
  const [shopName, setShopName] = useState("");
  const [shopNumber, setShopNumber] = useState("");
  const [shopEmail, setShopEmail] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setShopName("");
      setShopNumber("");
      setShopEmail("");
      setError({});
    }
  }, [open]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(number);
  };

  const handleAddShop = async () => {
    const newError = {};
    const tenantId = sessionStorage.getItem("tenantId") || "";
    const userRole = sessionStorage.getItem("userRole") || "";

    if (userRole !== "superadmin" && !tenantId) {
      setError({ shopEmail: "Tenant context is missing. Please sign in again." });
      return;
    }

    if (!shopName) {
      newError.shopName = "Shop name is required";
    }

    if (!validatePhoneNumber(shopNumber)) {
      newError.shopNumber =
        "Phone number must be 10 digits long and contain only numbers";
    }

    if (!validateEmail(shopEmail)) {
      newError.shopEmail =
        'Invalid email address. It should contain "@" and "."';
    }

    if (Object.keys(newError).length === 0) {
      setLoading(true);
      try {
        const shopQuery =
          userRole === "superadmin"
            ? query(
                collection(firestore, "shops"),
                where("email", "==", shopEmail)
              )
            : query(
                collection(firestore, "shops"),
                where("email", "==", shopEmail),
                where("tenantId", "==", tenantId)
              );
        const querySnapshot = await getDocs(shopQuery);

        if (!querySnapshot.empty) {
          setError({ shopEmail: "Shop with this email already exists" });
          setLoading(false);
          return;
        }

        const newShopUID = doc(collection(firestore, "shops")).id;

        await setDoc(doc(firestore, "shops", newShopUID), {
          email: shopEmail,
          role: "shop",
          shopName: shopName,
          shopNumber: shopNumber,
          tenantId: userRole === "superadmin" ? null : tenantId,
          createdAt: new Date(),
        });

        handleClose();
      } catch (error) {
        console.error("Error adding shop: ", error);
      } finally {
        setLoading(false);
      }
    } else {
      setError(newError);
    }
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setShopNumber(value);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Business Vendor</DialogTitle>
      <DialogContent>
        <TextField
          label="Shop Name"
          value={shopName}
          onChange={(e) => setShopName(e.target.value)}
          fullWidth
          margin="normal"
          error={Boolean(error.shopName)}
          helperText={error.shopName}
        />
        <TextField
          label="Shop Number"
          value={shopNumber}
          onChange={handlePhoneNumberChange}
          fullWidth
          margin="normal"
          error={Boolean(error.shopNumber)}
          helperText={error.shopNumber}
        />
        <TextField
          label="Shop Email"
          value={shopEmail}
          onChange={(e) => setShopEmail(e.target.value)}
          fullWidth
          margin="normal"
          error={Boolean(error.shopEmail)}
          helperText={error.shopEmail}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleAddShop} color="primary" disabled={loading}>
          {loading ? "Adding..." : "Add Business Vendor"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddShopPopup;
